import Vue from 'vue'
import breadcrumb from './breadcrumb.vue'
import subNav from './subnav.vue'
import topNav from './topnav.vue'
import { searchFilterWrapper, searchFilter } from './layout/search-filter/index.js'
import formCodeSearch from './form/form-code-search.vue'
import ZgCatalog from "@/components/ZgCatalog.vue";
import ZgSelectJg from "@/components/ZgSelectJg.vue";
import CmaCatalog from "@/components/CmaCatalog.vue";
import HwOne from "@/components/HwOne.vue";
import HwTwo from "@/components/HwTwo.vue";

Vue.component('breadcrumb', breadcrumb)
Vue.component('topNav', topNav)
Vue.component('subNav', subNav)
Vue.component('searchFilterWrapper', searchFilterWrapper)
Vue.component('searchFilter', searchFilter)
Vue.component('formCodeSearch', formCodeSearch)
Vue.component('ZgCatalog', ZgCatalog)
Vue.component('ZgSelectJg', ZgSelectJg)
Vue.component('CmaCatalog', CmaCatalog)
Vue.component('HwOne', HwOne)
Vue.component('HwTwo', HwTwo)